// Cookie/analytics consent — single source of truth.
// Value is one of: "accepted" | "declined" | null (undecided).
const KEY = "db_consent";
export const CONSENT_ACCEPTED = "accepted";
export const CONSENT_DECLINED = "declined";
const EVENT = "db:consent-change";

export function getConsent() {
    if (typeof window === "undefined") return null;
    try {
        return localStorage.getItem(KEY);
    } catch {
        return null;
    }
}

export function setConsent(value) {
    if (typeof window === "undefined") return;
    try {
        localStorage.setItem(KEY, value);
    } catch {
        /* localStorage blocked — event still fires for in-session behaviour */
    }
    window.dispatchEvent(new CustomEvent(EVENT, { detail: value }));
}

// Resets to undecided so the banner re-appears (used by "Cookie Preferences").
export function clearConsent() {
    if (typeof window === "undefined") return;
    try {
        localStorage.removeItem(KEY);
    } catch {
        /* noop */
    }
    window.dispatchEvent(new CustomEvent(EVENT, { detail: null }));
}

export function onConsentChange(cb) {
    if (typeof window === "undefined") return () => {};
    const handler = (e) => cb(e.detail);
    window.addEventListener(EVENT, handler);
    return () => window.removeEventListener(EVENT, handler);
}
